import { render, staticRenderFns } from "./indexThree.vue?vue&type=template&id=61b48a07&scoped=true&"
import script from "./indexThree.vue?vue&type=script&lang=js&"
export * from "./indexThree.vue?vue&type=script&lang=js&"
import style0 from "./indexThree.vue?vue&type=style&index=0&id=61b48a07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b48a07",
  null
  
)

export default component.exports